var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 18,
  viewBox: "0 0 14 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#579FFD",
  fillRule: "evenodd",
  d: "M.016 15.6h13.968v2.016H.016V15.6zm13.968-9L7 13.584.016 6.6H4v-6h6v6h3.984z"
})));
export default __webpack_public_path__ + "static/media/icon-download.6585c356.svg";
export { SvgComponent as ReactComponent };